import { ScoopText } from '../ScoopText/ScoopText'
import { ScoopInfoTooltip } from '../ScoopInfoTooltip/ScoopInfoTooltip'
import styles from './ScoopSwitch.module.scss'

export const ScoopSwitch = ({
    label,
    checked,
    onChange,
    name,
    icon,
    direction = 'row',
    tooltip,
    disabled = false,
    className = '',
    labelClassName = '',
    ...props
}) => {
    const hasLabel = label || icon || tooltip

    const switchClassName = [styles.switch, disabled && styles.disabled].filter(Boolean).join(' ')

    const handleClick = (e) => {
        e.stopPropagation()
    }

    const switchToggle = (
        <label className={switchClassName} onClick={handleClick}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                name={name}
                disabled={disabled}
                className={styles.input}
                {...props}
            />
            <span className={styles.slider} />
        </label>
    )

    if (!hasLabel) {
        return switchToggle
    }

    const containerClassName = [styles.switchContainer, styles[direction], className]
        .filter(Boolean)
        .join(' ')

    return (
        <div className={containerClassName}>
            <div className={styles.labelContainer}>
                {icon && <span className={styles.icon}>{icon}</span>}
                {label && (
                    <ScoopText className={`${styles.label} ${labelClassName}`}>{label}</ScoopText>
                )}
                {tooltip && <ScoopInfoTooltip title={tooltip} />}
            </div>
            {switchToggle}
        </div>
    )
}
